module.exports = __webpack_public_path__ + "img/logo.22be150d.png";